module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsValentine.29ece8d.jpg";